import React from "react";
import { ReduxDispatch, ReduxState } from "ducks/reducers";
import {
    SetHeader,
    ShowLogo,
    ShowBackNavigationWithRoute,
    SetShowBackNavigation,
} from "ducks/common";
import { connect } from "react-redux";
import { Grid } from "material-ui";
import DocumentsList, {
    DocumentListType,
    ListItem,
} from "./components/DocumentsList";
import {
    fetchDocumentationsData,
    documentationsSelector,
} from "ducks/documentations";
import FullPageSpinner from "components/FullPageSpinner/FullPageSpinner";
import {
    DocumentDto,
    DocumentStatus,
    DocumentationType,
} from "util/DTOs/DocumentationsDtos";

interface OwnProps {}

interface StateProps {
    loading: boolean;
    documents: Array<DocumentDto>;
}

interface DispatchProps {
    setHeaderValue: (h: string) => void;
    showLogo: (s: boolean) => void;
    setBackButton: (route: string) => void;
    hideBackButton: () => void;
    getDocumentationsData: () => Promise<DocumentDto[]>;
}

type Props = OwnProps & DispatchProps & StateProps;

const styles: React.CSSProperties = {
    container: { margin: 0, width: "100%" },
};

class DocumentationsPage extends React.Component<Props> {
    constructor(props: Props) {
        super(props);
    }

    public componentDidMount() {
        this.props.setBackButton("/");
        this.props.setHeaderValue("Asiakirjat");
        window.scrollTo(0, 0);
        this.props.getDocumentationsData();
    }

    public render() {
        const { documents, loading } = this.props;
        const unsigned = documents.filter(
            (d) => d.status === DocumentStatus.MissingSignature
        );
        const savingsAccountStatements = documents.filter(
            (d) =>
                d.status === DocumentStatus.Available &&
                d.type === DocumentationType.SavingsAccountStatements
        );
        const savingsAccountContracts = documents.filter(
            (d) =>
                d.status === DocumentStatus.Available &&
                d.type === DocumentationType.SavingsAccountContracts
        );
        const mortgageContracts = documents.filter(
            (d) =>
                d.status === DocumentStatus.Available &&
                d.type === DocumentationType.MortgageContracts
        );
        const generalTerms = documents.filter(
            (d) =>
                d.status === DocumentStatus.Available &&
                d.type === DocumentationType.GeneralTerms
        );
        return (
            <div>
                <div className="page-container" style={{ paddingTop: 18 }}>
                    <Grid container style={styles.container}>
                        {unsigned && unsigned.length > 0 && (
                            <DocumentsList
                                items={unsigned}
                                header={"Odottaa allekirjoitusta"}
                                listType={DocumentListType.Signable}
                            />
                        )}
                    </Grid>
                    <Grid container style={styles.container}>
                        {savingsAccountStatements &&
                            savingsAccountStatements.length > 0 && (
                                <DocumentsList
                                    items={savingsAccountStatements}
                                    header={"Talletustili"}
                                    subheader={"Tiliotteet"}
                                    listType={DocumentListType.Downloadable}
                                />
                            )}
                    </Grid>
                    <Grid container style={styles.container}>
                        {savingsAccountContracts &&
                            savingsAccountContracts.length > 0 && (
                                <DocumentsList
                                    items={savingsAccountContracts}
                                    subheader={"Sopimukset"}
                                    listType={DocumentListType.Downloadable}
                                />
                            )}
                    </Grid>
                    <Grid container style={styles.container}>
                        {mortgageContracts && mortgageContracts.length > 0 && (
                            <DocumentsList
                                items={mortgageContracts}
                                header={"Asuntolaina"}
                                subheader={"Sopimukset ja todistukset"}
                                listType={DocumentListType.Downloadable}
                            />
                        )}
                    </Grid>
                    <Grid container style={styles.container}>
                        {generalTerms && generalTerms.length > 0 && (
                            <DocumentsList
                                items={generalTerms}
                                header={"Yleiset"}
                                subheader={"Sopimus- ja lainaehdot"}
                                listType={DocumentListType.Downloadable}
                            />
                        )}
                    </Grid>
                    <FullPageSpinner loading={loading} />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: ReduxState): StateProps => {
    return {
        loading: state.documentations.loading,
        documents: documentationsSelector(state),
    };
};

const mapDispatchToProps = (dispatch: ReduxDispatch): DispatchProps => {
    return {
        setHeaderValue: (header) => {
            return dispatch(SetHeader(header));
        },
        showLogo: (show: boolean) => {
            return dispatch(ShowLogo(show));
        },
        setBackButton: (route: string) => {
            dispatch(ShowBackNavigationWithRoute(route));
        },
        hideBackButton: () => {
            dispatch(SetShowBackNavigation(false));
        },
        getDocumentationsData: async () => dispatch(fetchDocumentationsData()),
    };
};

export default connect<StateProps, DispatchProps, Props>(
    mapStateToProps,
    mapDispatchToProps
)(DocumentationsPage);



// WEBPACK FOOTER //
// ./src/views/documentation/DocumentationsPage.tsx